import { EstadoCargando, EstadoError, EstadoNoContratado, EstadoSinPermiso } from '../../componentes/EstadoPagina';
import { rolesDe } from '../../logica/acceso';
import { estadoDeError } from '../../logica/estados';
import type { PropsPantalla } from '../tipos';

/** Estados de página de «Listas y RRPP» (0.4): sin permiso, no contratado («Listas y RRPP»), error con reintento y cargando. */
export function SinPermiso({ props, seccion }: { props: PropsPantalla; seccion: string }) {
    const { membresia, nombreNegocio, navegar, movil } = props;
    return <EstadoSinPermiso seccion={seccion} rol={membresia === undefined ? '' : rolesDe(membresia)} negocio={nombreNegocio} onInicio={() => { navegar('/'); }} movil={movil} />;
}

export function EstadoDelError({ props, error, seccion, nombre, onReintentar }: { props: PropsPantalla; error: unknown; seccion: string; nombre: string; onReintentar: () => void }) {
    const e = estadoDeError(error);
    if (e.tipo === 'sin-permiso') {
        return <SinPermiso props={props} seccion={seccion} />;
    }
    if (e.tipo === 'no-contratado') {
        return (
            <EstadoNoContratado
                bloque="Listas y RRPP"
                texto="Listas de invitados por Instagram o email, tus RRPP con sus enlaces y sus comisiones liquidadas cuando tú quieras."
                incluye={['Listas con aforo, hora límite y cierre, copiadas de tus plantillas', 'Un enlace de Instagram por RRPP y evento, con el QR en el chat y sin IA', 'Comisiones por lista, evento o RRPP y liquidaciones con sus pagos']}
                propietario={props.membresia?.is_owner === true}
                onAnadir={props.membresia?.is_owner === true ? () => { props.navegar('/plan?block=listas_rrpp'); } : null}
                onInicio={() => { props.navegar('/'); }}
                movil={props.movil}
            />
        );
    }
    return <EstadoError seccion={nombre} codigoSoporte={e.codigoSoporte} onReintentar={onReintentar} movil={props.movil} />;
}

export function Cargando({ nombre }: { nombre: string }) {
    return <EstadoCargando seccion={nombre} />;
}
